const API_URI = "http://calculator.propi.kr:81/api/";

const IP_PORT = "http://calculator.propi.kr:81";

const SERVICE_URI = "https://calculator.propi.kr/";

module.exports = { API_URI, IP_PORT, SERVICE_URI };
